import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow-left\"><path d=\"M461.994667 512l181.034666 181.034667a42.666667 42.666667 0 1 1-60.330666 60.330666l-211.2-211.2a42.666667 42.666667 0 0 1 0-60.330666l211.2-211.2a42.666667 42.666667 0 1 1 60.330666 60.330666L461.994667 512z\" p-id=\"4282\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol